export default "__VITE_ASSET__CzWHYrsz__"